import {
  Component,
  Input,
  OnInit,
  inject,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormBuilder, UntypedFormGroup, FormsModule } from "@angular/forms";
import { PasswordValidator } from "./password.validator";
import { Bind } from "primeng/bind";
import { Password } from "primeng/password";

@Component({
  selector: "app-password",
  templateUrl: "./password.component.html",
  styleUrls: ["./password.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Password, FormsModule],
})
export class PasswordComponent implements OnInit {
  private formBuilder = inject(FormBuilder);

  @Input() public password;
  readonly passwordChanged = output<string>();

  public form: UntypedFormGroup;

  ngOnInit() {
    this.form = this.createForm();
  }

  public changePassword(password) {
    this.password = password;
    this.form.controls.password.setValue(password);
    if (this.form.valid) {
      this.passwordChanged.emit(password);
    }
  }

  public createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      password: [null, PasswordValidator.strong],
    });
  }
}
